import { useOnlineStock } from "@/hooks/useOnlineStock/useOnlineStock";
import { DeliveryOption } from "./DeliveryOption";

const ONLINE_STOCK_AVAILABILITY_STATUS_SPECIAL_ORDER =
  "SKU_AVAILABLE_FOR_SPECIAL_ORDER";

type Props = {
  index: number;
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  headline: string;
  description: string;
  displayPrice: string;
  stockApiBaseUrl: string;
  stockApiKey: string;
};

export function StandardDeliveryOption({
  index,
  skuId,
  isAvailableToOrderOrPreorder,
  headline,
  description,
  displayPrice,
  stockApiBaseUrl,
  stockApiKey,
}: Props) {
  const { isLoading, error, data } = useOnlineStock(
    skuId,
    stockApiBaseUrl,
    stockApiKey,
  );

  const getStandardDeliveryDescriptionOverride = () => {
    if (!isAvailableToOrderOrPreorder) return null;
    if (isLoading) return "";
    if (error) return null;
    if (
      data?.availabilityStatus ===
      ONLINE_STOCK_AVAILABILITY_STATUS_SPECIAL_ORDER
    ) {
      return data.stockMessage;
    }
    return null;
  };

  return (
    <DeliveryOption
      index={index}
      headline={headline}
      description={getStandardDeliveryDescriptionOverride() || description}
      displayPrice={displayPrice}
    />
  );
}
